import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { Button } from '@termly-web/react-components'

import arrowIcon from 'assets/images/arrow-back.svg'

import Locale from './locale'

import Styles from './styles.scss'


export default function BackButton({ show, handleClick }) {
  if ( !show ) {
    return null
  }

  const buttonClassName = `${ Styles.button } t-backButton`

  return (
    <div className={ Styles.root }>
      <Button
        className={ buttonClassName }
        handleClick={ handleClick }
        type="text"
      >
        <img
          alt=""
          className={ Styles.icon }
          src={ arrowIcon }
        />
        <FormattedMessage { ...Locale.back } />
      </Button>
    </div>
  )
}

BackButton.propTypes = {
  handleClick: PropTypes.func,
  show: PropTypes.bool,
}
